<template>
    <el-dialog custom-class="balance-dialog-class"  title="余额详情" :visible.sync="dialogVisible" @close = "closeBalanceDetail" width="1000px" :close-on-click-modal="false" :show-close="false">                
        
        <el-card shadow="never">
            <el-form :model="balanceDetail" label-width="100px" :inline="true">
                <el-form-item label="流水类型：">
                    <el-select class="form-select" v-model="balanceDetail.type" placeholder="请选择流水类型" size="mini">
                        <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item >
                    <el-button class="ml20" type="primary" @click="getData" size="small" :disabled="balanceDetail.loading">查询</el-button>
                    <el-button @click="getData" size="small" :disabled="balanceDetail.loading">取消</el-button>
                </el-form-item>
            </el-form>
            
        </el-card>
        <el-table class="table-class" size="small" :max-height="editBalanceHeight" :data="balanceDetail.tableData" style="width: 100%;" border header-row-class-name="header-row-class-name" header-cell-class-name="header-class-name" cell-class-name="cell-class-name">
            <el-table-column prop="" label="流水类型" >
                <template scope="scope">
                    <span>{{scope.row.change_kind}}</span>
                </template>
            </el-table-column> 
            <el-table-column prop="old_money" label="交易前金额" >
                <template scope="scope">
                    <span>¥{{scope.row.old_money}}</span>
                </template>
            </el-table-column>
            <el-table-column prop="" label="变动金额" >
                <template scope="scope">
                    <span :class="scope.row.change_type == 'IN'?'csuccess':'cdanger'">¥{{scope.row.change_type == 'IN'?'+':'-'}}{{scope.row.money}}</span>
                </template>
            </el-table-column>
            <el-table-column prop="new_money" label="变动后金额" ></el-table-column>            
            <el-table-column prop="" label="备注" width="270px">
                <template scope="scope">
                    <div size="mini">
                        <div>¥{{ scope.row.notes }}</div>
                    </div>
                </template>
            </el-table-column>
            <el-table-column prop="add_time" label="修改时间" width="180px"></el-table-column>
           
        </el-table>
        <div class="flexX  pageBox flexEnd">
            <el-pagination :disabled="balanceDetail.loading" @size-change="handleSizeChangeMoney" @current-change="handleCurrentChangeMoney" :current-page="balanceDetail.page" :page-sizes="balanceDetail.pageSizesArr" :page-size="balanceDetail.pageSize" layout="total, sizes, prev, pager, next" :total="balanceDetail.total"></el-pagination>
        </div>
        <div slot="footer" class="dialog-footer">
            <el-button size="mini" @click="closeBalanceDetail" :disabled="balanceDetail.loading">关 闭</el-button>
        </div>
    </el-dialog>
</template>
<script>

export default {
    props: {
        dialogVisible:{
            type: Boolean,
            default: false,
        },

    },
    data(){
        return{
            editBalanceHeight:0,
            balanceDetail:{
                tableData:[],
                page:1,
                pageSizesArr:[10,50,200,500],
                total:0,
                pageSize: 10,
                loading:false,
                type:''
            },
            options:[]
        }
    },
    mounted(){
        console.log('mounted',this.dialogVisible)
        this.moneyChangeKindOptions()
        this.getBalanceDetailHeight()
        this.getData()
    },
    methods:{
        //筛选项查询
        moneyChangeKindOptions(){
            this.$api.moneyChangeKindOptions({}).then(res=>{ 
                // console.log(res,'res')
                if(res.status == 1){ 
                    this.options = res.data
                }else{

                }
            })
        },
        closeBalanceDetail(){
            this.$emit('closeBalanceDetail')
        },
        getData(){
            this.balanceDetail.page = 1
            this.moneyChangeList()
        },
        //余额详情
        // getBalanceDetail(item){
        //         this.getBalanceDetailHeight()
        //         this.balanceDetail.visible = true
        //         this.$nextTick(() => {		
        //             this.getDialogTop('balance-dialog-class')
        //         })
                                
        //         this.dialog.form.id=item.id
        //         this.moneyChangeList()
        // },
          //余额详情接口
          moneyChangeList(){
                let data ={
                    "size": this.balanceDetail.pageSize,
                    "page":  this.balanceDetail.page,
                    "change_kind":this.balanceDetail.type,
                }
                this.balanceDetail.loading = true;
                this.$api.profileMoneyChangeList(data).then(res=>{
                    this.getBalanceDetailHeight()
                    this.balanceDetail.loading = false;
                    if(res.status == 1){
                        this.balanceDetail.tableData = res.data.data  
                        this.balanceDetail.total = res.data.total     
                        this.$nextTick(() => {		
                            // this.getDialogTop('balance-dialog-class')
                        })                
                    }else{
                        Message({
                            message: res.msg,
                            type: 'error',
                            duration: 3 * 1000
                        });
                    }
                }).catch(e=>{
                    this.balanceDetail.loading = false;
                })
            },
            // 余额分页查询数据
            handleSizeChangeMoney(val){
                this.balanceDetail.pageSize = val;
                this.balanceDetail.page = 1
                this.balanceDetail.total = 0
                this.moneyChangeList()
            },
            handleCurrentChangeMoney(val){
                this.balanceDetail.page = val
                this.moneyChangeList()
            },
         //计算余额弹窗内表格高度
         getBalanceDetailHeight(){
                this.$nextTick(() => {			
                    let documentHeight = document.documentElement.clientHeight
                    console.log('documentHeight',documentHeight)
                    this.editBalanceHeight =( documentHeight / 2) 
                })
            },
    },
}
</script>
<style lang="scss">
.balance-dialog-class{
    .el-dialog__body{
        padding-top: 0 !important;
    }
    .el-dialog__header{
        padding-bottom: 16px !important;
    }
    .el-form-item{
        margin-bottom: 0 !important;
    }
}
</style>
<style lang="scss" scoped>
.balance-dialog-class{   
    .form-select{
        width: 150px;
    }
    .table-class{
        margin-top: 16px;
    }
    .pageBox{
        padding: 16px 20px;
        border-top: 1px solid #ebeef5;
        background-color: #fafcff;
    }
    
}
    
</style>